export default {
    header: {
        text1: "الصفحة الرئيسية",
        text2: "كيفية اللعب",
        text3: "السوق",
        text4: "تسجيل الدخول",
    },
    home: {
        text1: "أول لعبة صيد تعتمد على البلوكشين في العالم",
        text2: "صيد، اكسب واستمتع",
        text3: "ابدأ اللعب الآن",
        text4: "متوفرة أيضًا على",
        text5: "متجر آبل",
        text6: "جوجل بلاي",
        text7: "تطبيق أندرويد",
        text8: "تعال قريبًا~",
    },
};
